import React from 'react';

export const FileScanningLoader = () => <span className="fileScanningLoader"></span>;
